import { FileTextOutlined } from '@ant-design/icons';
import { Card, List, PageHeader } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { NavLink } from 'react-router-dom';

export function ReportsPage() {
  const reports = [
    {
      title: 'Görev sayıları',
      link: '/reports/task-counts',
      description: 'Tamamlanan ve tamamlanmayan görev sayıları.',
    },
    {
      title: 'Görev tamamlama performansı',
      link: '/reports/task-performances',
      description: 'Görev tamamlama sürelerine göre performans durumu.',
    },
    {
      title: 'Veri elemanı iş kuralları',
      link: '/reports/field-rules',
      description: 'Veri elemanları için tanımlanmış iş kuralları listesi.',
    },
    {
      title: 'Mükerrer kayıtlar',
      link: '/reports/duplicate-records',
      description: 'Veri setlerinde tespit edilen olası mükerrer kayıtların listesi.',
    },
    {
      title: 'PLM Kalem - Mastar eşleştirmeleri',
      link: '/reports/plm-items-jigs',
      description: 'Veri setlerinde tespit edilen olası mükerrer kayıtların listesi.',
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <FileTextOutlined /> Raporlar
          </>
        }
      />
      <Content>
        <Card>
          <List
            dataSource={reports}
            renderItem={report => (
              <List.Item key={report.link}>
                <List.Item.Meta title={<NavLink to={report.link}>{report.title}</NavLink>} description={report.description} />
              </List.Item>
            )}
          />
        </Card>
      </Content>
    </>
  );
}
